import { Box, Stack, Typography } from '@mui/material';
import { formatAmountStat, parseAmountStats } from './utils';

export type RatesAmountStatsProps = {
  value: unknown;
};

const amountBoxSx = {
  width: '100%',
  boxSizing: 'border-box',
  border: 1,
  borderStyle: 'dashed',
  borderColor: 'divider',
  borderRadius: 1,
  bgcolor: 'background.paper',
  px: 1.5,
  py: 1,
};

const RatesAmountStats = ({ value }: RatesAmountStatsProps) => {
  const amountStats = parseAmountStats(value);

  return (
    <Box sx={{ width: '100%', mb: 1 }}>
      <Typography component="div" fontWeight={700} sx={{ mb: 1 }}>
        Total spend
      </Typography>
      <Stack spacing={0.5}>
        {amountStats.length > 0 ? (
          amountStats.map((item, index) => (
            <Box key={index} sx={amountBoxSx}>
              {formatAmountStat(item)}
            </Box>
          ))
        ) : (
          <Box sx={amountBoxSx}>$0</Box>
        )}
      </Stack>
    </Box>
  );
};

export default RatesAmountStats;
